import routerOptions0 from "/opt/buildhome/repo/app/router.options.ts";
import routerOptions1 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.6.5_@types+node@18.0.0_eslint@8.46.0_sass@1.63.6_typescript@5.1.6/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}